import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="mx-auto flex max-w-shell flex-col items-center px-4 py-24 text-center md:px-6">
        <p className="font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的内容可能已被移动或删除。回到首页看看刚上新的动态，或者去话题库翻一翻。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            回到首页
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-compass-3-line" aria-hidden="true" />
            浏览话题库
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}